import constants from '../../settings/constants';
import { applicationSettings } from '../../settings/application';
import productsService from '../../services/products';
import { ITEMS } from '../../constants';

interface padding {
  top: number;
  bottom: number;
  left: number;
  right: number;
  front?: number;
  back?: number;
}

const defaultPadding: padding = {
  top: 100,
  bottom: 100,
  left: 100,
  right: 100,
};

function getMixedModePadding(item: any): padding {
  if (productsService.isShelvingUnit(item)) {
    return {
      ...defaultPadding,
      top: -200,
    };
  } else if (productsService.isType(item, ITEMS.FRAME)) {
    return {
      ...defaultPadding,
      top: -200,
      left: -(item.width / 2),
      right: -(item.width / 2),
    };
  } else if (productsService.isType(item, [ITEMS.CABINET, 'box'])) {
    return {
      ...defaultPadding,
      top: 0,
      bottom: 0,
      left: -(item.width / 3),
      right: -(item.width / 3),
    };
  }

  return { ...defaultPadding };
}

function getInsertModePadding(item: any): padding {
  if (
    productsService.isType([ITEMS.SHELF, ITEMS.METAL_SHELF, ITEMS.WIRE_SHELF])
  ) {
    switch (applicationSettings.applicationName) {
      case 'BOAXEL': {
        return {
          ...defaultPadding,
          top: 50,
          bottom: 50,
        };
      }
      case 'IVAR': {
        return {
          ...defaultPadding,
          top: 30,
          bottom: 30,
        };
      }
      default:
        break;
    }
  } else if (
    productsService.isType(item, ITEMS.SHOE_SHELF) &&
    applicationSettings.applicationName === 'BOAXEL'
  ) {
    return {
      ...defaultPadding,
      bottom: 300,
      front: constants.ROOM_DEPTH,
      back: constants.ROOM_DEPTH,
    };
  }
  return {
    ...defaultPadding,
    front: constants.ROOM_DEPTH,
    back: constants.ROOM_DEPTH,
  };
}

export function snapPadding(mode: number, item: any): padding {
  if (item) {
    if (mode === constants.DRAG_MODE.MIXED) {
      return getMixedModePadding(item);
    }
    if (mode === constants.DRAG_MODE.INSERT) {
      return getInsertModePadding(item);
    }
  }

  return { ...defaultPadding };
}
